import React, { useEffect, useMemo, useState } from "react";
import {
  Container,
  Row,
  Card,
  Col,
  Modal,
  Form,
  Button,
  Offcanvas,
  Badge,
} from "react-bootstrap";
import DataTable from "react-data-table-component";
import Breadcrumb from "Common/BreadCrumb";
import { Link, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import Flatpickr from "react-flatpickr";
import { useFetchClassesQuery } from "features/classes/classeSlice";
import { useFetchEnseignantsQuery } from "features/enseignants/enseignantSlice";
import {
  useAddDisciplineMutation,
  useDeleteDisciplineMutation,
  useFetchDisciplinesQuery,
  useBulkDeleteDisciplinesMutation,
} from "features/disciplines/disciplineSlice";
import { useFetchEtudiantsByClasseIdMutation } from "features/etudiants/etudiantSlice";

import { French } from "flatpickr/dist/l10n/fr";
import { formatDate } from "helpers/data_time_format";
import { convertToBase64 } from "helpers/base64_convert";
import {
  useFetchSmsSettingsQuery,
  useUpdateSmsSettingByIdMutation,
} from "features/smsSettings/smsSettings";
import Select from "react-select";
import UpdateDiscipline from "./UpdateDiscipline";

const typeBadge: Record<string, { bg: string; icon: string }> = {
  Leçon: { bg: "warning", icon: "ri-book-open-line" },
  Exclu: { bg: "danger", icon: "ri-user-unfollow-line" },
  Honneur: { bg: "success", icon: "ri-award-line" },
};

const Discipline = () => {
  const { data = [] } = useFetchDisciplinesQuery();
  const { data: AllClasses = [] } = useFetchClassesQuery();
  const { data: AllEnseignants = [] } = useFetchEnseignantsQuery();
  const { data: AllSmsSettings, isLoading = [] } = useFetchSmsSettingsQuery();

  const [fetchEtudiantsByClasseId, { data: fetchedEtudiants }] =
    useFetchEtudiantsByClasseIdMutation();

  const [deleteDiscipline] = useDeleteDisciplineMutation();
  const [bulkDeleteDisciplines] = useBulkDeleteDisciplinesMutation();

  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [toggleCleared, setToggleCleared] = useState(false);

  const handleRowSelected = (state: any) => {
    setSelectedRows(state.selectedRows);
  };

  const handleBulkDelete = async () => {
    if (selectedRows.length === 0) return;
    const result = await swalWithBootstrapButtons.fire({
      title: "Suppression groupée",
      text: `Supprimer ${selectedRows.length} discipline(s) sélectionnée(s) ?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Oui, supprimer !",
      cancelButtonText: "Annuler",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      const ids = selectedRows.map((r: any) => r._id);
      await bulkDeleteDisciplines(ids).unwrap();
      setToggleCleared(!toggleCleared);
      setSelectedRows([]);
      notifySuccess(`${ids.length} discipline(s) supprimée(s)`);
    }
  };

  const [showObservation, setShowObservation] = useState<boolean>(false);

  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const handleDateChange = (selectedDates: Date[]) => {
    setSelectedDate(selectedDates[0]);
  };

  const notifySuccess = (msg: string) => {
    Swal.fire({
      position: "center",
      icon: "success",
      title: msg,
      showConfirmButton: false,
      timer: 2500,
    });
  };

  const notifyError = (err: any) => {
    Swal.fire({
      position: "center",
      icon: "error",
      title: `Une erreur est survenue: ${err}`,
      showConfirmButton: false,
      timer: 2500,
    });
  };

  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: "btn btn-success",
      cancelButton: "btn btn-danger",
    },
    buttonsStyling: false,
  });

  const AlertDelete = async (_id: any) => {
    swalWithBootstrapButtons
      .fire({
        title: "Etes-vous sûr?",
        text: "Vous ne pouvez pas revenir en arrière?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Oui, supprime-le !",
        cancelButtonText: "Non, annuler !",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteDiscipline(_id);
          swalWithBootstrapButtons.fire(
            "Supprimé !",
            "La discipline est supprimée.",
            "success"
          );
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          swalWithBootstrapButtons.fire(
            "Annulé",
            "La discipline est en sécurité :)",
            "info"
          );
        }
      });
  };

  const [students, setStudents] = useState<any[]>([]);
  const [selectedClasse, setSelectedClasse] = useState<string>("");

  const handleSelectClasse = async (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const value = event.target.value;
    const result = await fetchEtudiantsByClasseId(value).unwrap();
    setStudents(result);
    setSelectedClasse(value);
  };

  const [selectedPar, setSelectedPar] = useState<string>("");
  const handleSelectPar = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedPar(event.target.value);
  };

  const optionColumnsTable = [...students].sort((a: any, b: any) => (`${a.prenom} ${a.nom}`).localeCompare(`${b.prenom} ${b.nom}`, "fr")).map((eleve: any) => ({
    value: eleve?._id!,
    label: `${eleve?.prenom!} ${eleve?.nom!}`,
  }));

  const [selectedColumnValues, setSelectedColumnValues] = useState<any[]>([]);
  const handleSelectValueColumnChange = (selectedOption: any) => {
    const values = selectedOption.map((option: any) => option.value);
    setSelectedColumnValues(values);
  };

  const [selectedType, setSelectedType] = useState<string>("");
  const handleSelectType = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedType(event.target.value);
  };

  const [modal_AddObservation, setmodal_AddObservation] =
    useState<boolean>(false);
  function tog_AddObservation() {
    setmodal_AddObservation(!modal_AddObservation);
  }

  const [modal_UpdateDiscipline, setmodal_UpdateDiscipline] =
    useState<boolean>(false);
  function tog_UpdateDiscipline() {
    setmodal_UpdateDiscipline(!modal_UpdateDiscipline);
  }

  const [updateAvisSmsSetting] = useUpdateSmsSettingByIdMutation();
  const [formData, setFormData] = useState({
    id: "",
    status: "",
  });

  useEffect(() => {
    if (AllSmsSettings !== undefined && isLoading === false) {
      const devoir_sms_setting = AllSmsSettings?.filter(
        (parametre) => parametre.service_name === "Disciplines"
      );
      setFormData((prevState) => ({
        ...prevState,
        id: devoir_sms_setting[0]?._id!,
        status: devoir_sms_setting[0]?.sms_status!,
      }));
    }
  }, [AllSmsSettings, isLoading]);

  const onChangeDisciplineSmsSetting = () => {
    let updateData = {
      id: formData.id,
      status: formData.status === "1" ? "0" : "1",
    };
    updateAvisSmsSetting(updateData)
      .then(() =>
        setFormData((prevState) => ({
          ...prevState,
          status: formData.status === "1" ? "0" : "1",
        }))
      )
      .then(() =>
        notifySuccess("Paramètre Disciplines SMS a été modifié avec succès")
      );
  };

  const [createObservation] = useAddDisciplineMutation();

  const initialObservation = {
    eleve: [""],
    type: "",
    texte: "",
    editeur: "",
    date: "",
    fichier_base64_string: "",
    fichier_extension: "",
    fichier: "",
    classe: "",
  };

  const [observation, setObservation] = useState(initialObservation);

  const onChangeObservation = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setObservation((prevState) => ({
      ...prevState,
      [e.target.id]: e.target.value,
    }));
  };

  const handleFileUploadFile = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = (
      document.getElementById("fichier_base64_string") as HTMLFormElement
    ).files[0];
    if (file) {
      const { base64Data, extension } = await convertToBase64(file);
      const file_observation = base64Data + "." + extension;
      setObservation({
        ...observation,
        fichier: file_observation,
        fichier_base64_string: base64Data,
        fichier_extension: extension,
      });
    }
  };

  const onSubmitObservation = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      observation["date"] = formatDate(selectedDate);
      observation["eleve"] = selectedColumnValues;
      observation["type"] = selectedType;
      observation["editeur"] = selectedPar;
      observation["classe"] = selectedClasse;
      createObservation(observation)
        .then(() => notifySuccess("La discipline a été créée avec succès"))
        .then(() => setObservation(initialObservation));
    } catch (error) {
      notifyError(error);
    }
  };

  // Filters
  const [filterType, setFilterType] = useState<string>("");
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  // Stats
  const stats = useMemo(() => {
    const lecons = data.filter((d: any) => d.type === "Leçon").length;
    const exclus = data.filter((d: any) => d.type === "Exclu").length;
    const autres = data.length - lecons - exclus;
    return { total: data.length, lecons, exclus, autres };
  }, [data]);

  const getFilteredDisciplines = () => {
    let filtered = [...data];

    if (filterType) {
      filtered = filtered.filter((d: any) => d.type === filterType);
    }

    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      filtered = filtered.filter((discipline: any) => {
        const eleveMatch = discipline?.eleve?.some(
          (eleve: any) =>
            eleve?.nom?.toLowerCase().includes(term) ||
            eleve?.prenom?.toLowerCase().includes(term)
        );
        const typeMatch = discipline?.type?.toLowerCase().includes(term);
        const dateMatch = discipline?.date?.toLowerCase().includes(term);
        const editeurMatch = discipline?.editeur?.toLowerCase().includes(term);
        const texteMatch = discipline?.texte?.toLowerCase().includes(term);
        return eleveMatch || typeMatch || dateMatch || editeurMatch || texteMatch;
      });
    }

    return filtered.reverse();
  };

  const columns = [
    {
      name: <span className="fw-semibold fs-13">Elève(s)</span>,
      selector: (row: any) => row?.eleve?.[0]?.nom || "",
      cell: (row: any) => (
        <div className="d-flex align-items-center gap-2">
          <div className="avatar-xs flex-shrink-0">
            <div className="avatar-title bg-primary-subtle text-primary rounded-circle fs-16">
              <i className="ri-user-3-line" />
            </div>
          </div>
          <div>
            {row?.eleve?.map((e: any, i: number) => (
              <span key={e._id} className="d-block fs-13">
                {e.prenom} {e.nom}
                {i < row.eleve.length - 1 && ","}
              </span>
            ))}
          </div>
        </div>
      ),
      sortable: true,
      grow: 2,
    },
    {
      name: <span className="fw-semibold fs-13">Type</span>,
      selector: (row: any) => row.type,
      cell: (row: any) => {
        const badge = typeBadge[row.type] || { bg: "secondary", icon: "ri-information-line" };
        return (
          <Badge bg={`${badge.bg}-subtle`} text={badge.bg as any} className="fs-12 px-2 py-1">
            <i className={`${badge.icon} me-1`} />
            {row.type}
          </Badge>
        );
      },
      sortable: true,
    },
    {
      name: <span className="fw-semibold fs-13">Date</span>,
      selector: (row: any) => row.date,
      cell: (row: any) => (
        <span className="text-muted fs-13">
          <i className="ri-calendar-line me-1 text-primary" />
          {row.date}
        </span>
      ),
      sortable: true,
    },
    {
      name: <span className="fw-semibold fs-13">Éditeur</span>,
      selector: (row: any) => row.editeur,
      cell: (row: any) => (
        <span className="fs-13">
          <i className="ri-user-settings-line me-1 text-muted" />
          {row.editeur}
        </span>
      ),
      sortable: true,
    },
    {
      name: <span className="fw-semibold fs-13">Description</span>,
      selector: (row: any) => row.texte || "",
      cell: (row: any) => (
        <span className="text-muted fs-13 text-truncate d-inline-block" style={{ maxWidth: 180 }}>
          {row.texte || "—"}
        </span>
      ),
      sortable: false,
    },
    {
      name: <span className="fw-semibold fs-13">Actions</span>,
      cell: (row: any) => (
        <div className="d-flex gap-1">
          <Link
            to="#"
            state={row}
            className="btn btn-soft-info btn-sm btn-icon"
            onClick={() => setShowObservation(true)}
            title="Voir détails"
          >
            <i className="ri-eye-line" />
          </Link>
          <Link
            to="#"
            state={row}
            className="btn btn-soft-success btn-sm btn-icon"
            onClick={() => tog_UpdateDiscipline()}
            title="Modifier"
          >
            <i className="ri-edit-2-line" />
          </Link>
          <button
            className="btn btn-soft-danger btn-sm btn-icon"
            onClick={() => AlertDelete(row._id)}
            title="Supprimer"
          >
            <i className="ri-delete-bin-2-line" />
          </button>
        </div>
      ),
    },
  ];

  const observationLocation = useLocation();

  const openFileInNewTab = (fileUrl: string, fileName: string) => {
    const link = document.createElement("a");
    link.href = fileUrl;
    link.target = "_blank";
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleButtonClick = () => {
    const fileUrl = `${process.env.REACT_APP_BASE_URL}/disciplineFiles/${observationLocation.state.fichier}`;
    openFileInNewTab(fileUrl, "discipline.pdf");
  };

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#f3f6f9",
        fontWeight: "600",
        fontSize: "13px",
        color: "#495057",
        borderBottom: "2px solid #e9ebec",
      },
    },
    rows: {
      style: {
        fontSize: "13px",
        "&:hover": {
          backgroundColor: "#f3f6f9",
        },
      },
    },
    pagination: {
      style: {
        borderTop: "1px solid #e9ebec",
      },
    },
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Discipline" pageTitle="Tableau de bord" />

          {/* KPI Cards */}
          <Row className="mb-3">
            <Col sm={6} xl={3}>
              <Card className="card-animate border-0 shadow-sm cursor-pointer" onClick={() => setFilterType("")}>
                <Card.Body>
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm flex-shrink-0">
                      <span className="avatar-title bg-primary-subtle text-primary rounded-circle fs-3">
                        <i className="ri-shield-line" />
                      </span>
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <p className="text-uppercase fw-medium text-muted mb-1 fs-13">Total</p>
                      <h4 className="mb-0">{stats.total}</h4>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col sm={6} xl={3}>
              <Card
                className={`card-animate border-0 shadow-sm cursor-pointer ${filterType === "Leçon" ? "border-warning border-2" : ""}`}
                onClick={() => setFilterType(filterType === "Leçon" ? "" : "Leçon")}
              >
                <Card.Body>
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm flex-shrink-0">
                      <span className="avatar-title bg-warning-subtle text-warning rounded-circle fs-3">
                        <i className="ri-book-open-line" />
                      </span>
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <p className="text-uppercase fw-medium text-muted mb-1 fs-13">Leçons</p>
                      <h4 className="mb-0 text-warning">{stats.lecons}</h4>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col sm={6} xl={3}>
              <Card
                className={`card-animate border-0 shadow-sm cursor-pointer ${filterType === "Exclu" ? "border-danger border-2" : ""}`}
                onClick={() => setFilterType(filterType === "Exclu" ? "" : "Exclu")}
              >
                <Card.Body>
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm flex-shrink-0">
                      <span className="avatar-title bg-danger-subtle text-danger rounded-circle fs-3">
                        <i className="ri-user-unfollow-line" />
                      </span>
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <p className="text-uppercase fw-medium text-muted mb-1 fs-13">Exclusions</p>
                      <h4 className="mb-0 text-danger">{stats.exclus}</h4>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col sm={6} xl={3}>
              <Card className="card-animate border-0 shadow-sm">
                <Card.Body>
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm flex-shrink-0">
                      <span className="avatar-title bg-info-subtle text-info rounded-circle fs-3">
                        <i className="ri-chat-settings-line" />
                      </span>
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <p className="text-uppercase fw-medium text-muted mb-1 fs-13">SMS</p>
                      <div className="form-check form-switch mb-0">
                        <input
                          key={formData?.id!}
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          id={formData.id}
                          checked={formData.status === "1"}
                          onChange={() => onChangeDisciplineSmsSetting()}
                        />
                        {formData.status === "0" ? (
                          <span className="badge bg-warning-subtle text-warning">Désactivé</span>
                        ) : (
                          <span className="badge bg-success-subtle text-success">Activé</span>
                        )}
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Data Table */}
          <Col lg={12}>
            <Card className="border-0 shadow-sm">
              <Card.Header className="border-bottom-dashed bg-white">
                <Row className="g-3 align-items-center">
                  <Col lg={4} md={6}>
                    <div className="search-box">
                      <input
                        type="text"
                        className="form-control search"
                        placeholder="Rechercher par nom, type, éditeur..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                      />
                      <i className="ri-search-line search-icon"></i>
                    </div>
                  </Col>
                  <Col lg={3} md={3}>
                    <select
                      className="form-select"
                      value={filterType}
                      onChange={(e) => setFilterType(e.target.value)}
                    >
                      <option value="">Tous les types</option>
                      <option value="Leçon">Leçon</option>
                      <option value="Exclu">Exclu</option>
                    </select>
                  </Col>
                  <Col lg={5} md={3} className="d-flex justify-content-end gap-2">
                    {filterType && (
                      <Button
                        variant="soft-secondary"
                        size="sm"
                        onClick={() => { setFilterType(""); setSearchTerm(""); }}
                      >
                        <i className="ri-filter-off-line me-1" />
                        Réinitialiser
                      </Button>
                    )}
                    <Button
                      variant="primary"
                      onClick={() => tog_AddObservation()}
                      className="d-flex align-items-center gap-1"
                    >
                      <i className="ri-add-line fs-16" />
                      Nouvelle discipline
                    </Button>
                  </Col>
                </Row>
              </Card.Header>
              {selectedRows.length > 0 && (
                <div className="bg-primary-subtle border-bottom p-3 d-flex align-items-center gap-3">
                  <span className="fw-semibold text-primary">
                    {selectedRows.length} sélectionné(s)
                  </span>
                  <Button variant="danger" size="sm" onClick={handleBulkDelete} className="d-flex align-items-center gap-1">
                    <i className="ri-delete-bin-2-line" />
                    Supprimer
                  </Button>
                  <Button variant="soft-secondary" size="sm" onClick={() => { setToggleCleared(!toggleCleared); setSelectedRows([]); }}>
                    <i className="ri-close-line me-1" />
                    Annuler
                  </Button>
                </div>
              )}
              <Card.Body className="p-0">
                <DataTable
                  columns={columns}
                  data={getFilteredDisciplines()}
                  selectableRows
                  selectableRowsVisibleOnly
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleCleared}
                  pagination
                  paginationPerPage={15}
                  paginationRowsPerPageOptions={[10, 15, 25, 50]}
                  customStyles={customStyles}
                  noDataComponent={
                    <div className="text-center py-5">
                      <i className="ri-shield-line fs-1 text-muted d-block mb-2" />
                      <p className="text-muted mb-0">Aucune discipline trouvée</p>
                    </div>
                  }
                  paginationComponentOptions={{
                    rowsPerPageText: "Lignes par page",
                    rangeSeparatorText: "sur",
                  }}
                  highlightOnHover
                  responsive
                />
              </Card.Body>
            </Card>
          </Col>

          {/* Add Modal */}
          <Modal
            className="fade"
            show={modal_AddObservation}
            onHide={() => tog_AddObservation()}
            centered
            size="lg"
          >
            <Modal.Header closeButton className="bg-primary-subtle">
              <h5 className="modal-title d-flex align-items-center gap-2">
                <i className="ri-shield-star-line fs-20" />
                Nouvelle discipline
              </h5>
            </Modal.Header>
            <Modal.Body className="px-4 py-3">
              <Form className="create-form" onSubmit={onSubmitObservation}>
                <p className="text-muted fs-12 text-uppercase fw-semibold mb-3">
                  <i className="ri-user-line me-1" />
                  Élève & Classe
                </p>
                <Row className="g-3 mb-4">
                  <Col md={6}>
                    <Form.Label htmlFor="classe" className="fw-medium">
                      <i className="ri-group-line me-1 text-primary" />
                      Classe <span className="text-danger">*</span>
                    </Form.Label>
                    <Select
                      options={[...AllClasses].sort((a: any, b: any) => (a.nom_classe || "").localeCompare(b.nom_classe || "", "fr")).map((classe) => ({
                        value: classe?._id!,
                        label: classe.nom_classe,
                      }))}
                      onChange={(opt: any) => { const e = { target: { value: opt?.value || "" } } as any; handleSelectClasse(e); }}
                      placeholder="Rechercher une classe..."
                      isClearable
                      isSearchable
                      noOptionsMessage={() => "Aucune classe trouvée"}
                    />
                  </Col>
                  <Col md={6}>
                    <Form.Label htmlFor="eleve" className="fw-medium">
                      <i className="ri-user-heart-line me-1 text-info" />
                      Élève(s) <span className="text-danger">*</span>
                    </Form.Label>
                    <Select
                      closeMenuOnSelect={false}
                      isMulti
                      options={optionColumnsTable}
                      onChange={handleSelectValueColumnChange}
                      placeholder="Sélectionner les élèves..."
                      noOptionsMessage={() => "Choisissez d'abord une classe"}
                    />
                  </Col>
                </Row>

                <hr className="text-muted" />
                <p className="text-muted fs-12 text-uppercase fw-semibold mb-3">
                  <i className="ri-information-line me-1" />
                  Détails de la discipline
                </p>
                <Row className="g-3 mb-4">
                  <Col md={4}>
                    <Form.Label htmlFor="type" className="fw-medium">
                      <i className="ri-price-tag-3-line me-1 text-warning" />
                      Type <span className="text-danger">*</span>
                    </Form.Label>
                    <select
                      className="form-select"
                      name="type"
                      id="type"
                      onChange={handleSelectType}
                      required
                    >
                      <option value="">Sélectionner le type</option>
                      <option value="Leçon">Leçon</option>
                      <option value="Exclu">Exclu</option>
                    </select>
                  </Col>
                  <Col md={4}>
                    <Form.Label htmlFor="date" className="fw-medium">
                      <i className="ri-calendar-line me-1 text-success" />
                      Date <span className="text-danger">*</span>
                    </Form.Label>
                    <Flatpickr
                      className="form-control"
                      placeholder="Sélectionner la date"
                      onChange={handleDateChange}
                      options={{
                        dateFormat: "d-M-Y",
                        locale: French,
                      }}
                      id="date"
                      name="date"
                    />
                  </Col>
                  <Col md={4}>
                    <Form.Label htmlFor="par" className="fw-medium">
                      <i className="ri-user-settings-line me-1 text-muted" />
                      Éditeur <span className="text-danger">*</span>
                    </Form.Label>
                    <Select
                      options={[
                        { value: "Administration", label: "Administration" },
                        ...[...AllEnseignants].sort((a: any, b: any) => (`${a.nom_enseignant} ${a.prenom_enseignant}`).localeCompare(`${b.nom_enseignant} ${b.prenom_enseignant}`, "fr")).map((enseignant: any) => ({
                          value: `${enseignant.nom_enseignant} ${enseignant.prenom_enseignant}`,
                          label: `${enseignant.nom_enseignant} ${enseignant.prenom_enseignant}`,
                        })),
                      ]}
                      onChange={(opt: any) => { const e = { target: { value: opt?.value || "" } } as any; handleSelectPar(e); }}
                      placeholder="Rechercher un éditeur..."
                      isClearable
                      isSearchable
                      noOptionsMessage={() => "Aucun éditeur trouvé"}
                    />
                  </Col>
                </Row>

                <hr className="text-muted" />
                <p className="text-muted fs-12 text-uppercase fw-semibold mb-3">
                  <i className="ri-attachment-2 me-1" />
                  Description & pièce jointe
                </p>
                <Row className="g-3">
                  <Col md={12}>
                    <Form.Label htmlFor="texte" className="fw-medium">
                      <i className="ri-file-text-line me-1 text-muted" />
                      Description
                    </Form.Label>
                    <textarea
                      className="form-control"
                      id="texte"
                      name="texte"
                      value={observation.texte}
                      onChange={onChangeObservation}
                      rows={3}
                      placeholder="Détails de la discipline..."
                    />
                  </Col>
                  <Col md={12}>
                    <Form.Label htmlFor="fichier_base64_string" className="fw-medium">
                      <i className="ri-upload-cloud-2-line me-1 text-warning" />
                      Fichier joint
                    </Form.Label>
                    <div className="input-group">
                      <span className="input-group-text bg-light">
                        <i className="ri-file-pdf-line text-danger" />
                      </span>
                      <input
                        className="form-control"
                        type="file"
                        id="fichier_base64_string"
                        name="fichier_base64_string"
                        onChange={(e) => handleFileUploadFile(e)}
                      />
                    </div>
                    <small className="text-muted">PDF, Image ou document (optionnel)</small>
                  </Col>
                </Row>
                <div className="hstack gap-2 justify-content-end border-top mt-4 pt-3">
                  <Button
                    variant="light"
                    onClick={() => {
                      tog_AddObservation();
                      setObservation(initialObservation);
                    }}
                  >
                    <i className="ri-close-line me-1" />
                    Annuler
                  </Button>
                  <Button
                    onClick={() => tog_AddObservation()}
                    type="submit"
                    variant="primary"
                  >
                    <i className="ri-check-line me-1" />
                    Enregistrer
                  </Button>
                </div>
              </Form>
            </Modal.Body>
          </Modal>

          {/* Update Modal */}
          <Modal
            className="fade"
            show={modal_UpdateDiscipline}
            onHide={() => tog_UpdateDiscipline()}
            centered
            size="lg"
          >
            <Modal.Header closeButton className="bg-success-subtle">
              <h5 className="modal-title">
                <i className="ri-edit-2-line me-2" />
                Modifier discipline
              </h5>
            </Modal.Header>
            <Modal.Body>
              <UpdateDiscipline
                modal_UpdateDiscipline={modal_UpdateDiscipline}
                setmodal_UpdateDiscipline={setmodal_UpdateDiscipline}
              />
            </Modal.Body>
          </Modal>
        </Container>

        {/* Detail Offcanvas */}
        <Offcanvas
          show={showObservation}
          onHide={() => setShowObservation(false)}
          placement="end"
          style={{ width: "420px" }}
        >
          <Offcanvas.Header closeButton className="border-bottom bg-light">
            <Offcanvas.Title className="d-flex align-items-center gap-2">
              <i className="ri-shield-line text-primary fs-20" />
              Détails de la discipline
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="mb-4">
              <label className="text-muted text-uppercase fs-11 fw-semibold mb-2 d-block">
                Élève(s)
              </label>
              {observationLocation?.state?.eleve?.map((eleve: any) => (
                <div key={eleve._id} className="d-flex align-items-center gap-2 mb-2">
                  <div className="avatar-xs">
                    <div className="avatar-title bg-primary-subtle text-primary rounded-circle">
                      {eleve.prenom?.[0]}{eleve.nom?.[0]}
                    </div>
                  </div>
                  <span className="fw-medium">{eleve.prenom} {eleve.nom}</span>
                </div>
              ))}
            </div>

            <div className="mb-4">
              <label className="text-muted text-uppercase fs-11 fw-semibold mb-2 d-block">
                Type
              </label>
              {(() => {
                const t = observationLocation?.state?.type || "";
                const badge = typeBadge[t] || { bg: "secondary", icon: "ri-information-line" };
                return (
                  <Badge bg={`${badge.bg}-subtle`} text={badge.bg as any} className="fs-13 px-3 py-2">
                    <i className={`${badge.icon} me-1`} />
                    {t}
                  </Badge>
                );
              })()}
            </div>

            <div className="mb-4">
              <label className="text-muted text-uppercase fs-11 fw-semibold mb-2 d-block">
                Description
              </label>
              <p className="mb-0">{observationLocation?.state?.texte || "—"}</p>
            </div>

            <Row className="mb-4 g-3">
              <Col xs={6}>
                <label className="text-muted text-uppercase fs-11 fw-semibold mb-2 d-block">
                  Date
                </label>
                <span>
                  <i className="ri-calendar-line me-1 text-primary" />
                  {observationLocation?.state?.date}
                </span>
              </Col>
              <Col xs={6}>
                <label className="text-muted text-uppercase fs-11 fw-semibold mb-2 d-block">
                  Éditeur
                </label>
                <span>
                  <i className="ri-user-settings-line me-1 text-muted" />
                  {observationLocation?.state?.editeur}
                </span>
              </Col>
            </Row>

            {observationLocation?.state?.fichier && observationLocation.state.fichier !== "" && (
              <div>
                <label className="text-muted text-uppercase fs-11 fw-semibold mb-2 d-block">
                  Fichier joint
                </label>
                <Button variant="soft-danger" size="sm" onClick={handleButtonClick} className="d-flex align-items-center gap-1">
                  <i className="ri-file-pdf-line fs-16" />
                  Ouvrir le fichier
                </Button>
              </div>
            )}
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </React.Fragment>
  );
};
export default Discipline;
